webpackJsonp([14],{

/***/ 2755:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _general = __webpack_require__(113);

var _get_android_app = __webpack_require__(2756);

var _get_android_app2 = _interopRequireDefault(_get_android_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);
    var androidAppDownloadLink = config.AndroidAppDownloadLink;

    return {
        androidAppDownloadLink: androidAppDownloadLink
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_get_android_app2.default);

/***/ }),

/***/ 2756:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = GetAndroidApp;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _reactRouterDom = __webpack_require__(269);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _url = __webpack_require__(793);

var _androidChrome192x = __webpack_require__(312);

var _androidChrome192x2 = _interopRequireDefault(_androidChrome192x);

var _nexus6pMockup = __webpack_require__(2757);

var _nexus6pMockup2 = _interopRequireDefault(_nexus6pMockup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function GetAndroidApp(_ref) {
    var androidAppDownloadLink = _ref.androidAppDownloadLink;

    return _react2.default.createElement(
        'div',
        { className: 'get-app get-android-app' },
        _react2.default.createElement(
            'h1',
            { className: 'get-app__header' },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'get_app.androidHeader',
                defaultMessage: 'Mattermost works best if you switch to our Android app'
            })
        ),
        _react2.default.createElement('hr', null),
        _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement('img', {
                className: 'get-android-app__icon',
                src: _androidChrome192x2.default
            }),
            _react2.default.createElement(
                'div',
                { className: 'get-android-app__app-info' },
                _react2.default.createElement(
                    'span',
                    { className: 'get-android-app__app-name' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'get_app.androidAppName',
                        defaultMessage: 'Mattermost for Android'
                    })
                ),
                _react2.default.createElement(
                    'span',
                    { className: 'get-android-app__app-creator' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'get_app.mattermostInc',
                        defaultMessage: 'Mattermost, Inc'
                    })
                )
            )
        ),
        _react2.default.createElement(
            'a',
            {
                className: 'btn btn-primary get-android-app__continue',
                href: (0, _url.useSafeUrl)(androidAppDownloadLink)
            },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'get_app.continue',
                defaultMessage: 'Continue'
            })
        ),
        _react2.default.createElement('img', {
            className: 'get-app__screenshot',
            src: _nexus6pMockup2.default
        }),
        _react2.default.createElement(
            'span',
            { className: 'get-app__continue-with-browser' },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'get_app.continueWithBrowser',
                defaultMessage: 'Or {link}',
                values: {
                    link: _react2.default.createElement(
                        _reactRouterDom.Link,
                        { to: '/switch_team' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'get_app.continueWithBrowserLink',
                            defaultMessage: 'continue with browser'
                        })
                    )
                }
            })
        )
    );
} // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

GetAndroidApp.propTypes = {
    androidAppDownloadLink: _propTypes2.default.string
};

/***/ }),

/***/ 2757:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/06172d602eeaf18752e7dab208cc6eff.png";

/***/ })

});


// WEBPACK FOOTER //
// 14.3cd9cf72c88de3803729.js